<template>
  <DefLinkBrown
    v-if="service"
    class="product-credit-button"
    :disabled="product?.isPair && !isPairSelected"
    @click="handlerOpenModal"
  >
    <svg>
      <use xlink:href="#svg-credit"></use>
    </svg>
    {{ service.name }}
  </DefLinkBrown>
</template>

<script>
import { mapState } from 'vuex';
import DefLinkBrown from '@components/Def/DefLink/DefLinkBrown.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import ProductCreditModal from '@components/Product/ProductCredit/ProductCreditModal.vue';

export default {
  name: 'ProductCreditModal',
  components: { DefLinkBrown },
  props: ['service'],
  data() {
    return {
      isOpen: false,
      modalAside: useModalAside(),
    };
  },
  computed: {
    ...mapState({
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
      product: ({ product }) => product?.data?.product,
    }),
  },
  methods: {
    handlerOpenModal() {
      this.modalAside.show(ProductCreditModal);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-link-brown.product-credit-button {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  svg {
    fill: currentColor;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
}
</style>
